// extracted by mini-css-extract-plugin
export default {"ClusteredColumnSeries":"ClusteredColumnSeries--axubQ"};